import React, { useCallback, useContext, useEffect, useState } from 'react';
import logoIpp from '../../images/logoIpp.png';
import { AuthIppContext } from '../../contexts/authIpp';
import { getServiceHealthIpp } from '../../services/getServiceHealthIpp';

import './index.scss';

const StatusIpp: React.FC = () => {
  const [vendaOnline, setVendaOnline] = useState(false);
  const [comprasOnline, setComprasOnline] = useState(false);
  const [estoqueOnline, setEstoqueOnline] = useState(false);
  const [funcionariosOnline, setFuncionariosOnline] = useState(false);
  const [dataConsulta, setDataConsulta] = useState('00/00/0000 00:00');

  const { getToken } = useContext(AuthIppContext);

  useEffect(() => {
    updateStatusServicesipp();
    updateLastDateVerification();
  }, []);

  useEffect(() => {
    const timer = setInterval(async () => {
      await updateStatusServicesipp();
      updateLastDateVerification();
    }, Number(process.env.REACT_APP_TEMPO_RECONSULTA_STATUS_IPP));
    return () => clearInterval(timer);
  }, [vendaOnline]);

  const updateStatusServicesipp = async () => {
    const responseToken = await getToken();

    setVendaOnline(
      await getServiceHealthIpp(
        process.env.REACT_APP_URL_VENDA_HEALTH,
        responseToken,
      ),
    );
    setComprasOnline(
      await getServiceHealthIpp(
        process.env.REACT_APP_URL_COMPRAS_HEALTH,
        responseToken,
      ),
    );
    setEstoqueOnline(
      await getServiceHealthIpp(
        process.env.REACT_APP_URL_ESTOQUE_HEALTH,
        responseToken,
      ),
    );
    setFuncionariosOnline(
      await getServiceHealthIpp(
        process.env.REACT_APP_URL_FUNCIONARIOS_HEALTH,
        responseToken,
      ),
    );
  };

  const updateLastDateVerification = useCallback(() => {
    const date = new Date(Date.now());
    setDataConsulta(date.toLocaleString('pt-BR').toString());
  }, []);

  return (
    <div id="StatusIpp-Container">
      <div id="StatusLogoIpiranga">
        <img src={logoIpp} />
      </div>
      <div className={vendaOnline ? 'Status-Item-OK' : 'Status-Item-Fail'}>
        Vendas:
        <div className={vendaOnline ? 'LabelOnline' : 'LabelOffline'}>
          {vendaOnline ? 'ONLINE' : 'OFFLINE'}
        </div>
      </div>
      <div className={comprasOnline ? 'Status-Item-OK' : 'Status-Item-Fail'}>
        Compras:
        <div className={comprasOnline ? 'LabelOnline' : 'LabelOffline'}>
          {comprasOnline ? 'ONLINE' : 'OFFLINE'}
        </div>
      </div>
      <div className={estoqueOnline ? 'Status-Item-OK' : 'Status-Item-Fail'}>
        Estoque:
        <div className={estoqueOnline ? 'LabelOnline' : 'LabelOffline'}>
          {estoqueOnline ? 'ONLINE' : 'OFFLINE'}
        </div>
      </div>
      <div
        className={funcionariosOnline ? 'Status-Item-OK' : 'Status-Item-Fail'}
      >
        Funcionários:
        <div className={funcionariosOnline ? 'LabelOnline' : 'LabelOffline'}>
          {funcionariosOnline ? 'ONLINE' : 'OFFLINE'}
        </div>
      </div>
      <div id="TextoUltimaVerificacao">
        Data última verificação: {dataConsulta}
      </div>
    </div>
  );
};

export default StatusIpp;
